import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import CKEditor from "react-ckeditor-component";
import { useDispatch, useSelector } from "react-redux";
import {
  addSMSTemp,
  smsTempId,
  updateSMStemp,
} from "../../../../store/actions";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../../Common/extra/loading";

const AddSMSIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editId } = useParams();
  const TempData = useSelector((s) => s?.EmailTemplates?.smsTemplates?.data);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    userId: "",
    sms_template: "",
    name: "",
    status: "1",
    sms_template_type: "static",
  });

  useEffect(() => {
    if (editId && TempData) {
      setState({
        userId: TempData?.id,
        name: TempData?.name,
        sms_template: TempData.sms_template,
        status: TempData?.status,
      });
    }
  }, [TempData, editId]);

  useEffect(() => {
    if (editId) {
      dispatch(smsTempId(editId));
    }
  }, [editId]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setState((prevState) => ({
      ...prevState,
      sms_template: newContent,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let body = {
      name: state.name,
      sms_template: state.sms_template,
      sms_template_type: "static",
      status: "1",
    };
    const callBack = (res) => {
      if (res.data) {
        setLoading(false);
        toast.success(`SMS Template ${editId ? "Edited" : "Added"}!`);
        navigate("/sms-templates");
      } else {
        setLoading(false);
        toast.error("");
      }
    };
    if (editId) {
      dispatch(
        updateSMStemp(
          {
            name: state.name,
            sms_template: state.sms_template,
            status: "1",
            sms_template_type: "static",
            userId: editId,
          },
          callBack
        )
      );
    } else {
      dispatch(addSMSTemp(body, callBack));
    }
  };

  const handleCopy = (text) => {
    setState((pre) => ({
      ...pre,
      sms_template: state.sms_template + text,
    }));
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">SMS Templates</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <Form>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label for="" className="form-label2 m-0">
                        SMS Title
                      </label>
                      <input
                        type="text"
                        value={state.name}
                        name="name"
                        onChange={handleChange}
                        className="form-control"
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <label for="" className="form-label2 m-0">
                        Use this following Variables to send in email:
                      </label>
                      <label for="" className="form-label2 m-0 col-lg-12 mt-3">
                        User Variables:
                      </label>
                      <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                        <h5 onClick={() => handleCopy("{{userName}}")}>
                          {"{{userName}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userWorkPhone}}")}>
                          {"{{userWorkPhone}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userCellPhone}}")}>
                          {"{{userCellPhone}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userAddress}}")}>
                          {"{{userAddress}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userDOB}}")}>
                          {"{{userDOB}}"}
                        </h5>
                      </div>
                      <label for="" className="form-label2 m-0 col-lg-12 mt-3">
                        Admin Variables:
                      </label>
                      <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                        <h5 onClick={() => handleCopy("{{adminName}}")}>
                          {"{{adminName}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{adminMobileNumber}}")}>
                          {"{{adminMobileNumber}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{adminAddress}}")}>
                          {"{{adminAddress}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{adminRole}}")}>
                          {"{{adminRole}}"}
                        </h5>
                        <h5
                          onClick={() => handleCopy("{{adminRolePermission}}")}
                        >
                          {"{{adminRolePermission}}"}
                        </h5>
                      </div>

                      <label for="" className="form-label2 m-0 col-lg-12 mt-3">
                        Company Variables:
                      </label>
                      <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                        <h5 onClick={() => handleCopy("{{companyName}}")}>
                          {"{{companyName}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{companyAddress}}")}>
                          {"{{companyAddress}}"}
                        </h5>
                        <h5
                          onClick={() =>
                            handleCopy("{{companyWebsiteAddress}}")
                          }
                        >
                          {"{{companyWebsiteAddress}}"}
                        </h5>
                        <h5
                          onClick={() =>
                            handleCopy("{{companyEmailSignature}}")
                          }
                        >
                          {"{{companyEmailSignature}}"}
                        </h5>
                      </div>
                      {/* <div className="text-end pe-3 warning-varbles">
                        <span>*Please use this variables with brackets*</span>
                      </div> */}
                    </Col>
                    <Col lg="12" className="my-2">
                      <CKEditor
                        activeClass="p10"
                        content={state.sms_template}
                        events={{
                          change: onChange,
                        }}
                      />
                    </Col>
                  </Row>
                </Form>
                <Button
                  onClick={handleSubmit}
                  className="d-flex align-items-center justify-content-center"
                  disabled={
                    state.name == "" || state.sms_template == "" ? true : false
                  }
                >
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddSMSIndex;
